// Palette de couleurs pour distinguer chaque équipier
export const STAFF_PALETTE = [
  {
    bg: "bg-blue-50",
    border: "border-blue-200",
    text: "text-blue-700",
    dot: "bg-blue-500",
    badge: "bg-blue-100 text-blue-800 border-blue-200",
  },
  {
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    text: "text-emerald-700",
    dot: "bg-emerald-500",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  {
    bg: "bg-purple-50",
    border: "border-purple-200",
    text: "text-purple-700",
    dot: "bg-purple-500",
    badge: "bg-purple-100 text-purple-800 border-purple-200",
  },
  {
    bg: "bg-amber-50",
    border: "border-amber-200",
    text: "text-amber-700",
    dot: "bg-amber-500",
    badge: "bg-amber-100 text-amber-800 border-amber-200",
  },
  {
    bg: "bg-rose-50",
    border: "border-rose-200",
    text: "text-rose-700",
    dot: "bg-rose-500",
    badge: "bg-rose-100 text-rose-800 border-rose-200",
  },
  {
    bg: "bg-indigo-50",
    border: "border-indigo-200",
    text: "text-indigo-700",
    dot: "bg-indigo-500",
    badge: "bg-indigo-100 text-indigo-800 border-indigo-200",
  },
  {
    bg: "bg-cyan-50",
    border: "border-cyan-200",
    text: "text-cyan-700",
    dot: "bg-cyan-500",
    badge: "bg-cyan-100 text-cyan-800 border-cyan-200",
  },
];

// Couleur neutre si le rendez-vous n'est attribué à personne
export const UNASSIGNED_COLOR = {
  bg: "bg-slate-50",
  border: "border-slate-200",
  text: "text-slate-600",
  dot: "bg-slate-400",
  badge: "bg-slate-100 text-slate-700 border-slate-200",
};

/**
 * Attribue toujours la même couleur au même équipier à partir de son ID ou de son Nom
 */
export function getStaffColor(identifier) {
  if (!identifier) return UNASSIGNED_COLOR;

  const str = String(identifier);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % STAFF_PALETTE.length;
  return STAFF_PALETTE[index];
}